import React from "react";
import PropTypes from "kf-proptypes/widgets";
import {
  DndContext,
  closestCenter,
  useSensors,
  useSensor,
  PointerSensor,
  KeyboardSensor,
  useDroppable
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
  sortableKeyboardCoordinates
} from "@dnd-kit/sortable";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";

import { Row } from "./row.jsx";

import styles from "./styles.css";

DraggableList.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      FieldName: PropTypes.string,
      Action: PropTypes.string,
      Widget: PropTypes.string,
      Name: PropTypes.string
    })
  ),
  onChange: PropTypes.func.isRequired,
  itemComponent: PropTypes.node.isRequired,
  itemProps: PropTypes.shape({
    baseUrl: PropTypes.string,
    config: PropTypes.shape({
      allowFilterParams: PropTypes.bool
    }),
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        Id: PropTypes.string.isRequired,
        ReadOnly: PropTypes.bool,
        Width: PropTypes.string,
        Name: PropTypes.string.isRequired,
        Type: PropTypes.string,
        IsSystemField: PropTypes.bool,
        Model: PropTypes.string,
        Widget: PropTypes.node,
        Required: PropTypes.bool,
        IsInternal: PropTypes.bool
      })
    )
  })
};

export function DraggableList({
  list,
  onChange,
  itemComponent: Item,
  itemProps
}) {
  const { setNodeRef } = useDroppable({
    id: list.id
  });

  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })
  );

  function handleDragStart(event) {}

  function handleDragEnd(event) {
    const { active, over } = event;
    if (active && over) {
      const oldIndex = list.findIndex((field) => field.id === active.id);
      const newIndex = list.findIndex((field) => field.id === over.id);
      const sortedIds = arrayMove(list, oldIndex, newIndex);
      onChange(sortedIds);
    }
  }
  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      modifiers={[restrictToVerticalAxis]}
    >
      <SortableContext
        items={list.map((item) => item.id)}
        strategy={verticalListSortingStrategy}
      >
        <div
          className={styles.sortRowWrapper}
          onClick={(e) => e.stopPropagation()}
          ref={setNodeRef}
        >
          {list.map((item, index) => {
            return (
              <Row key={item.id} id={item.id} row={item}>
                <Item
                  item={item}
                  onChange={onChange}
                  actions={list}
                  {...itemProps}
                />
              </Row>
            );
          })}
        </div>
      </SortableContext>
    </DndContext>
  );
}
